import { List, Create, Edit, Users, CompUsersAdd, ParadeState, ParadeUsers } from "../Components/index.js";

export default [
    {
        path: "/admin/company-camp",
        component: List,
        name: "company-camp-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-camp/:id/edit",
        component: Edit,
        name: "company-camp-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-camp/create",
        component: Create,
        name: "company-camp-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/company-camp-users",
        component: Users,
        name: "company-camp-users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/company-camp-users/:camp_id",
        component: CompUsersAdd,
        name: "update-company-camp-users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company-camp",
        component: ParadeState,
        name: "report-company-camp",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company-camp-users",
        component: ParadeUsers,
        name: "report-company-camp-users",
        meta: {
            requiresAuth: true,
        },
    },
];
